import { getDefaultStatisticItem, getTeamLabelByNumber } from '../../utils/utils'

export default {
  statisticScheme: {
    'PT1': getDefaultStatisticItem('statistic.basketball.pt1'),
    'PT2': getDefaultStatisticItem('statistic.basketball.pt2'),
    'PT3': getDefaultStatisticItem('statistic.basketball.pt3'),
    'FOUL': getDefaultStatisticItem('statistic.foul'),
    'TIMEOUT': getDefaultStatisticItem('statistic.timeout')
  },
  statisticEvents: {
    'PT1': 'PT1',
    'PT2': 'PT2',
    'PT3': 'PT3',
    'FOUL': 'FOUL',
    'TIMEOUT': 'TIMEOUT'
  },
  statisticOrder: [
    'PT1',
    'PT2',
    'PT3',
    'FOUL',
    'TIMEOUT'
  ],
  statisticFunction (event, relatedEvent) {
    const eventForProcess = event.EventCode === 'CANCEL' ? relatedEvent : event

    const { EventCode } = eventForProcess

    if (!['FOUL', 'TECHNICAL_FOUL_PLAYER'].includes(EventCode)) return

    const { extra } = event
    const { fouls } = extra

    const foulsArray = fouls.split('-')
    event.extra['fouls-1'] = foulsArray[0]
    event.extra['fouls-2'] = foulsArray[1]

    this.setFouls(event)

    if (EventCode === 'FOUL') return

    const {
      getCurrentPeriod
    } = this
    const { GamePeriod, TeamNumber } = eventForProcess
    const baseProperties = {
      statisticType: 'defaultStatistic',
      property: 'FOUL',
      period: GamePeriod || getCurrentPeriod,
      team: getTeamLabelByNumber(TeamNumber),
      type: event.EventCode === 'CANCEL' ? 'decrement' : 'increment'
    }

    this.updateStatistic(baseProperties)
  }
}
